import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { clearAuthParamsFromUrl, finishAuthFromUrl } from '../lib/finish-auth-from-url';

export default function AuthCallback() {
  const navigate = useNavigate();
  const [message, setMessage] = useState('Autenticando…');

  useEffect(() => {
    let cancelled = false;

    void (async () => {
      const result = await finishAuthFromUrl();
      if (cancelled) return;

      clearAuthParamsFromUrl();

      if (result.ok) {
        navigate('/', { replace: true });
        return;
      }

      console.warn('[admin] auth callback:', result.error);
      setMessage(result.error);
      navigate(`/login?error=${encodeURIComponent(result.error)}`, { replace: true });
    })();

    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center">
      <div className="text-center text-muted px-3">
        <div className="spinner-border text-success mb-3" role="status" />
        <div>{message}</div>
        <Link to="/login" className="small d-block mt-3">
          Voltar ao login
        </Link>
      </div>
    </div>
  );
}
